interface VisualLike {
  type?: string;
  getSlicerState?: () => Promise<unknown>;
}

interface ActivePageWithVisuals {
  getVisuals: () => Promise<unknown[]>;
}

const isSlicerVisual = (visual: unknown): visual is VisualLike => {
  const visualType = ((visual as VisualLike)?.type || '')
    .toString()
    .toLowerCase();

  return visualType === 'slicer';
};

const getSlicerState = async (visual: VisualLike): Promise<unknown> => {
  try {
    if (typeof visual.getSlicerState !== 'function') {
      return null;
    }

    return await visual.getSlicerState();
  } catch (error) {
    console.warn('Error getting slicer state:', error);

    return null;
  }
};

const extractFiltersFromSlicerState = (slicerState: unknown): unknown[] => {
  const filters = (slicerState as { filters?: unknown })?.filters || [];

  return Array.isArray(filters) ? filters : [];
};

export const extractSlicerFilters = async (
  activePage: ActivePageWithVisuals
): Promise<unknown[]> => {
  try {
    const visuals = await activePage.getVisuals();

    if (!Array.isArray(visuals)) {
      return [];
    }

    const slicerFilters: unknown[] = [];

    for (const visual of visuals) {
      if (!isSlicerVisual(visual)) {
        continue;
      }

      const slicerState = await getSlicerState(visual);

      if (!slicerState) {
        continue;
      }

      const filters = extractFiltersFromSlicerState(slicerState);

      slicerFilters.push(...filters);
    }

    return slicerFilters;
  } catch (error) {
    console.warn('Error extracting slicer filters:', error);

    return [];
  }
};
